module.exports = __webpack_public_path__ + "img/1561622040.be624b74.jpg";